import 'shared/connector'

import './auth-check'
import { initSentry, integrateGTM } from 'shared/integrations'

export function init() {
	initSentry()
	integrateGTM()
}
